import React from 'react';
import Spinner from "../layout/Spinner";
import {useHistory, useLocation} from "react-router";
import {ParsedUrlQuery} from "querystring";
import {queryParams} from "../utils/index";
import {useKeycloak} from "@react-keycloak/web";

export const USER_REDIRECT = '/gip/utente';
export const LAB_REDIRECT = '/gip/laboratorio';
export const PUNTI_PRELIEVO_REDIRECT = '/gip/sgp';
export const ROOT_REDIRECT = '/gip';
export const SETUP_REDIRECT = '/gip/setup';
export const REQUESTS_REDIRECT = '/gip/requests';

export const USER_ROLE = 'user';
export const LAB_ROLE = 'lab-results';
export const PUNTI_PRELIEVO_ROLE = 'lab';
export const ADMIN_ROLE = 'admin';

/**
 * Sistema che permette di effettuare redirect al path (nel router) corretto associato al ruolo.
 * @returns {any}
 * @constructor
 */
const ReservedSwitcher = () => {
    //const auth = React.useContext(AuthContext);

    const { keycloak } = useKeycloak();

    const {token} = keycloak;
    const location = useLocation();
    const history = useHistory();
    // const permission = React.useContext(PermissionContext);

    React.useEffect(() => {

        if (token !== undefined && keycloak.authenticated) {
            const {token} = keycloak;

            if (keycloak?.hasRealmRole(USER_ROLE) || keycloak?.hasResourceRole(USER_ROLE)) {
                history.push(USER_REDIRECT);
            }

            if (keycloak?.hasRealmRole(LAB_ROLE) || keycloak?.hasResourceRole(LAB_ROLE)) {
                history.push(LAB_REDIRECT);
            }

            if (keycloak?.hasRealmRole(PUNTI_PRELIEVO_ROLE) || keycloak?.hasResourceRole(PUNTI_PRELIEVO_ROLE)) {
                history.push(PUNTI_PRELIEVO_REDIRECT);
            }

            if (keycloak?.hasRealmRole(ADMIN_ROLE) || keycloak?.hasResourceRole(ADMIN_ROLE)) {
                console.log('ADMINROLE')
                const queryMap: ParsedUrlQuery = queryParams(location.search);
                let status = '';

                console.log('STATUS ', queryMap['status']);


                if (queryMap['status'] === undefined) {
                    status = '?status=pending';
                }

                history.push(REQUESTS_REDIRECT+status);
            }
        }
    }, [keycloak.authenticated, token]);

    return (
        <Spinner/>
    )
};

export default ReservedSwitcher;